import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const CopyAnalyticsPage = loadAsyncComponent(() => import('./Container'), 'page');

export { PAGE_VIEW as ANALYTICS_PAGE_VIEW } from './lib';
